import { Route } from "react-router";
import { AuthLayout } from "@/layouts";
import {
  ForgotPassword,
  Login,
  Privacy,
  RecoverPassword,
  Register,
  ResetPassword,
  Terms,
} from "@/pages";
import React from "react";

/**
 * Route definitions for the authentication layout routes.
 * This includes login, registration, password recovery, and legal pages.
 */
export const authLayoutRoutes: React.ReactElement<any>[] = [
  <Route key="auth-layout" element={<AuthLayout />}>
    <Route path="/auth/login" element={<Login />} />
    {/* <Route path="/auth/token" element={<Token />} /> */}
    <Route path="/reset_password/" element={<ResetPassword />} />
    <Route path="/auth/register" element={<Register />} />
    <Route path="/auth/forgot-password" element={<ForgotPassword />} />
    <Route path="/reset_password/:code" element={<RecoverPassword />} />
    <Route path="/privacy" element={<Privacy />} />
    <Route path="/terms" element={<Terms />} />
  </Route>,
];
